import { render, staticRenderFns } from "./filter-areas.vue?vue&type=template&id=338c19e0&"
import script from "./filter-areas.vue?vue&type=script&lang=js&"
export * from "./filter-areas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports